import styled from 'styled-components';

import { ArrowBack, Close, Edit } from '@mui/icons-material';
import { Alert, Box, Button, Drawer, Typography } from '@mui/material';
import { wellzTheme } from '@wellz-theme/mui';

export const Container = styled(Drawer)``;

export const Wrapper = styled(Box)`
  height: 100%;
  width: ${wellzTheme.spacing(56.25)};
  background-color: white;
  overflow-y: auto;

  display: flex;
  flex-direction: column;

  padding-top: ${wellzTheme.spacing(2)};
  padding-bottom: ${wellzTheme.spacing(3)};
  padding-right: ${wellzTheme.spacing(3)};
  padding-left: ${wellzTheme.spacing(3)};
`;

export const Header = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: ${wellzTheme.spacing(4)};
`;

export const StepBackIcon = styled(ArrowBack)`
  width: ${wellzTheme.spacing(3)};
  height: ${wellzTheme.spacing(3)};
  fill: ${wellzTheme.palette.primary.main};
`;

export const CloseDrawerIcon = styled(Close)`
  width: ${wellzTheme.spacing(3)};
  height: ${wellzTheme.spacing(3)};
  fill: ${wellzTheme.palette.primary.main};
`;

export const MessagePreviewContainer = styled(Box)`
  flex: 1;
  border-radius: ${wellzTheme.shape.borderRadius * 2}px;
  background-color: ${wellzTheme.palette.action.disabledBackground};
  padding: ${wellzTheme.spacing(2)};

  margin-top: ${wellzTheme.spacing(2)};
`;

export const MessagePreviewText = styled(Typography).attrs({
  variant: 'body2',
  color: 'text.secondary',
})`
  b {
    font-weight: 500;
    color: ${wellzTheme.palette.text.secondary};
  }
`;

export const NextStepButton = styled(Button)`
  margin-top: ${wellzTheme.spacing(2)};
  margin-left: auto;
  width: fit-content;
`;

export const NextStepIcon = styled(Edit)`
  width: ${wellzTheme.spacing(2.25)};
  height: ${wellzTheme.spacing(2.25)};
  fill: ${wellzTheme.palette.primary.main};

  margin-right: ${wellzTheme.spacing(1)};
`;

export const CancelationBanner = styled(Alert)`
  margin-top: auto;

  svg {
    fill: ${wellzTheme.palette.primary.main};
  }
`;

export const FeedbackSuccess = styled(Alert)`
  svg {
    fill: ${wellzTheme.palette.success.main};
  }

  background-color: #acefce;
`;

export const FeedbackError = styled(Alert)`
  svg {
    fill: ${wellzTheme.palette.warning.contrastText};
  }

  p {
    color: ${wellzTheme.palette.warning.contrastText};
  }
`;
